import { render } from "./RiProdoffering04.vue?vue&type=template&id=ee8a78a4"
import script from "./RiProdoffering04.vue?vue&type=script&lang=js"
export * from "./RiProdoffering04.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering04.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee8a78a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee8a78a4', __exports__)) {
    api.reload('ee8a78a4', __exports__)
  }
  
  module.hot.accept("./RiProdoffering04.vue?vue&type=template&id=ee8a78a4", () => {
    api.rerender('ee8a78a4', render)
  })

}


export default __exports__